import { render, staticRenderFns } from "./StorageDialog.vue?vue&type=template&id=27939dfd&"
import script from "./StorageDialog.vue?vue&type=script&lang=js&"
export * from "./StorageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27939dfd')) {
      api.createRecord('27939dfd', component.options)
    } else {
      api.reload('27939dfd', component.options)
    }
    module.hot.accept("./StorageDialog.vue?vue&type=template&id=27939dfd&", function () {
      api.rerender('27939dfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/main2/components/StorageDialog.vue"
export default component.exports